<div *ngIf="touchpoint">
  <!-- Buttons -->
  <div class="ui-g-12 ui-md-6">
    <div class="campaign-button flex-align-center" (click)="openAddStores()">
      <div data-testid="AddStores" class="campaign-button__label">
        {{ 'campaign.add_stores' | translate }}
      </div>
      <div class="text-right">
        <i class="fa fa-arrow-right icon-campaign-arrow"></i>
      </div>
    </div>
  </div>
  <div class="ui-g-12 ui-md-6">
    <div data-testid="AddGroup" class="campaign-button flex-align-center" (click)="openAddGroup()">
      <div class="campaign-button__label">
        {{ 'campaign.addSavedGroup' | translate }}
      </div>
      <div class="text-right">
        <i class="fa fa-arrow-right icon-campaign-arrow"></i>
      </div>
    </div>
  </div>
  <!-- Lista Negozi -->
  <div class="ui-g-12">
    <h3>{{ touchpoint.label }}: {{ 'campaign.storeList' | translate }}</h3>
  </div>
  <div class="ui-g-12" *ngIf="touchpoint.stores && touchpoint.stores.length > 0">
    <div class="ui-g-12 ui-md-6 added-stores" *ngFor="let store of touchpoint.stores">
      <div class="ui-g-2">
        <div class="added-stores__code">{{ store.host_code }}</div>
      </div>
      <div class="ui-g-9">
        <div class="added-stores__name">
          {{ store.name }}
        </div>
        <div class="added-stores__address">
          {{ store.region }}<span *ngIf="store.region">, </span>{{ store.city }}<span *ngIf="store.city && store.address">, </span>{{ store.address }}
        </div>
      </div>
      <div class="ui-g-1">
        <a class="fa fa-trash red" (click)="removeStore(store.id)" aria-hidden="true"></a>
      </div>
    </div>
  </div>
  <!-- Dialog Aggiunta Negozi/Gruppi -->
  <p-dialog
    class="campaign-dialog"
    [positionTop]="40"
    [positionLeft]="'50%'"
    [header]="dialogTitle"
    [width]="1000"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeDialog()">
    <app-campaign-add-stores
      *ngIf="showAddStores"
      [selectedStoresId]="touchpoint.storesId"
      (onAddStores)="addStores($event)">
    </app-campaign-add-stores>
    <app-campaign-add-store-group
      *ngIf="showAddGroup"
      [selectedStoresId]="touchpoint.storesId"
      [selectedGroupsId]="touchpoint.groupId"
      (onAddStores)="addStores($event)"
    >
    </app-campaign-add-store-group>
  </p-dialog>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-store-list/campaign-store-list.component.html